module.exports = __webpack_public_path__ + "static/media/dashboard-default.d58a6bfa.png";